import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps } from './mobileMotion'

export default function Slide1M() {
  const { t } = useLanguage()
  const s = t.slides.slide1

  return (
    <MobileSlideShell>
      <motion.p
        {...fadeScaleProps(0)}
        className="text-center text-[13px] font-bold uppercase tracking-[0.2em] text-[#1B2A6B]/50"
      >
        {s.eyebrow}
      </motion.p>

      <motion.div {...fadeScaleProps(0.06)} className="flex flex-col items-center gap-1 text-center">
        <h1 className="text-[26px] font-semibold leading-[1.15] tracking-tight text-[#1B2A6B]">
          {s.headline1}{' '}
          <span className="font-semibold text-[#22A756]">65%</span>{' '}
          {s.headline2}
        </h1>
        <h1 className="text-[26px] font-semibold leading-[1.15] tracking-tight text-[#1B2A6B]">
          {s.headline3}
        </h1>
      </motion.div>

      <motion.div
        {...fadeScaleProps(0.12)}
        className="flex items-center justify-center gap-3"
      >
        <div className="h-[3px] w-12 rounded-full bg-[#22A756]" />
        <div className="h-2.5 w-2.5 rounded-full border-2 border-[#22A756]" />
        <div className="h-[3px] w-12 rounded-full bg-[#22A756]" />
      </motion.div>

      <motion.p
        {...fadeScaleProps(0.18)}
        className="text-center text-[16px] leading-relaxed text-[#1B2A6B]/65"
      >
        {s.subtitle}
      </motion.p>
    </MobileSlideShell>
  )
}
